import { Input, Icon, Stack } from '@chakra-ui/react';
import { LinkIcon } from '@heroicons/react/24/outline';
import { InputGroup } from '@/components/ui/input-group';
import { LinkBlock as ILinkBlock, LinkBlockPayload } from '@/lib/types';
import BaseInputBlock from './base-input-block';
import { useFillableBlockResponse } from './common';

interface Props {
  block: ILinkBlock;
}

function readPayload(payload: unknown): LinkBlockPayload {
  if (typeof payload === 'string') return { value: payload, text: '' };
  if (payload && typeof payload === 'object') {
    const p = payload as Partial<LinkBlockPayload>;
    return { value: p.value || '', text: p.text || '' };
  }
  return { value: '', text: '' };
}

export default function LinkBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });
  const { value: url, text } = readPayload(payload);

  return (
    <BaseInputBlock block={block}>
      <Stack w='full' gap={2}>
        <Input
          value={text}
          placeholder='Display text (optional)'
          onChange={(e) => updatePayload({ value: url, text: e.currentTarget.value })}
        />
        <InputGroup flex='1' startElement={<Icon as={LinkIcon} mr={2} w={4} h={4} />} w={'full'}>
          <Input
            id={`block-${block.referenceID}`}
            type={'url'}
            value={url}
            placeholder='https://yoursite.com'
            onChange={(e) => updatePayload({ value: e.currentTarget.value, text })}
          />
        </InputGroup>
      </Stack>
    </BaseInputBlock>
  );
}
